(function () {
  var EMAILJS_PUBLIC_KEY = 'X3TfskL8FvZEUdCkZ';
  var EMAILJS_SERVICE_ID = 'service_su80fcr';
  var EMAILJS_TEMPLATE_ID = 'template_q6jbmyq';

  // Load EmailJS SDK dynamically then initialize it
  var s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
  s.onload = function () {
    if (typeof emailjs !== 'undefined') {
      emailjs.init({ publicKey: EMAILJS_PUBLIC_KEY });
    }
  };
  document.head.appendChild(s);

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getLCUpchargeLine(item) {
    if (!item.properties) return 0;
    var total = 0;
    Object.keys(item.properties).forEach(function (key) {
      var val = item.properties[key] || '';
      var match = val.match(/\(\+?\$(\d[\d,]*)\)/);
      if (match) total += Math.round(parseFloat(match[1].replace(/,/g, '')) * 100);
    });
    return total * item.quantity;
  }

  function buildHtml(name, productItems, membershipItems, isLoggedInMember, phone, promoApplied) {
    var PICKUP_VID      = 49210694336740;
    var hasPickupCredit = productItems.some(function (i) { return i.variant_id == PICKUP_VID; });
    var productItems    = productItems.filter(function (i) { return i.variant_id != PICKUP_VID; });
    var allItems = productItems.concat(membershipItems);

    var itemsHtml = '';
    allItems.forEach(function (item) {
      var imgHtml = item.image
        ? '<img src="' + esc(item.image) + '" width="76" height="76" style="display:block;border-radius:4px;object-fit:cover;" alt="">'
        : '<div style="width:76px;height:76px;background:#e8e1d8;border-radius:4px;"></div>';

      var detailHtml = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        detailHtml += '<p style="margin:0 0 2px;font-size:12px;color:#777;">' + esc(item.variant_title) + '</p>';
      }
      if (item.sku) {
        detailHtml += '<p style="margin:0 0 4px;font-size:11px;color:#aaa;">SKU: ' + esc(item.sku) + '</p>';
      }
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          if (key.charAt(0) === '_') return;
          var val = item.properties[key];
          if (!val) return;
          detailHtml += '<p style="margin:0 0 2px;font-size:12px;color:#555;"><strong style="color:#333;">' + esc(key) + ':</strong> ' + esc(val) + '</p>';
        });
      }

      itemsHtml +=
        '<table width="100%" cellpadding="0" cellspacing="0" border="0" style="border:1px solid #e0d6c8;border-radius:6px;margin-bottom:12px;">' +
        '<tr>' +
        '<td width="88" style="padding:12px;vertical-align:top;">' + imgHtml + '</td>' +
        '<td style="padding:12px 12px 12px 0;vertical-align:top;">' +
        '<p style="margin:0 0 4px;font-size:14px;font-weight:bold;color:#1c1c1c;line-height:1.3;">' + esc(item.product_title) + '</p>' +
        detailHtml + '</td>' +
        '<td style="padding:12px;vertical-align:bottom;text-align:right;white-space:nowrap;">' +
        '<p style="margin:0;font-size:12px;color:#999;">Qty: ' + item.quantity + '</p>' +
        '<p style="margin:4px 0 0;font-size:15px;font-weight:bold;color:#1c1c1c;">' + fmt(item.final_line_price + getLCUpchargeLine(item)) + '</p>' +
        '</td></tr></table>';
    });

    var giftCardTotal = productItems.reduce(function (s, i) { return s + (i.url && i.url.indexOf('old-hippy-wood-products-gift-card') !== -1 ? i.original_line_price : 0); }, 0);
    var regularTotal  = productItems.reduce(function (s, i) { return s + i.original_line_price + getLCUpchargeLine(i); }, 0);
    var discountableTotal = regularTotal - giftCardTotal;
    var pickupCredit  = hasPickupCredit ? Math.min(Math.round(discountableTotal * 0.05), 75000) : 0;
    var hasMembership = membershipItems.length > 0 || !!isLoggedInMember;
    var preTaxTotal   = 0;
    var pricingHtml   = '<table width="100%" cellpadding="0" cellspacing="0" border="0" style="border:1px solid #e0d6c8;border-radius:6px;margin:8px 0 20px;">';

    if (hasMembership) {
      var rhVipFn = window.rhGetVipRate || function() { return 0.8; };
      var discountedItems = productItems.reduce(function(t, i) {
        var isGC = i.url && i.url.indexOf('old-hippy-wood-products-gift-card') !== -1;
        if (isGC) return t;
        return t + Math.round((i.original_line_price + getLCUpchargeLine(i)) * rhVipFn(i));
      }, 0);
      var vipSubtotal     = discountedItems + giftCardTotal;
      var membershipTotal = membershipItems.reduce(function (s2, i) { return s2 + i.final_line_price; }, 0);
      var vipFinalForEmail = vipSubtotal + membershipTotal - pickupCredit;
      var savings         = discountableTotal - discountedItems;
      pricingHtml +=
        '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:12px;color:#aaa;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">Regular Subtotal</td><td style="text-align:right;font-size:13px;color:#bbb;text-decoration:line-through;padding:9px 14px;">' + fmt(regularTotal) + '</td></tr>' +
        '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:12px;color:#555;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">VIP Member Subtotal (20% off)</td><td style="text-align:right;font-size:13px;color:#1c1c1c;padding:9px 14px;">' + fmt(vipSubtotal) + '</td></tr>' +
        (membershipItems.length > 0 ? '<tr style="border-bottom:' + (hasPickupCredit ? '1' : '2') + 'px solid #d5cdc3;"><td style="font-size:12px;color:#555;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">VIP Membership Fee (1 year)</td><td style="text-align:right;font-size:13px;color:#1c1c1c;padding:9px 14px;">' + fmt(membershipTotal) + '</td></tr>' : '');
      if (hasPickupCredit) {
        pricingHtml += '<tr style="border-bottom:2px solid #d5cdc3;"><td style="font-size:12px;color:#555;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">Edmonton Pickup Credit</td><td style="text-align:right;font-size:13px;color:#1c1c1c;padding:9px 14px;">&minus;' + fmt(pickupCredit) + '</td></tr>';
      }
      if (promoApplied) {
        var promoAmt = Math.round(vipFinalForEmail * 0.05);
        pricingHtml += '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:12px;color:#5a8a5a;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">&#127991; Promo Code WELCOME26 (5% off)</td><td style="text-align:right;font-size:13px;color:#5a8a5a;padding:9px 14px;">&minus;' + fmt(promoAmt) + '</td></tr>';
        vipFinalForEmail -= promoAmt;
      }
      preTaxTotal = vipFinalForEmail;
      pricingHtml +=
        '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:13px;font-weight:bold;color:#1c1c1c;padding:11px 14px;text-transform:uppercase;letter-spacing:0.08em;">VIP Member Total</td><td style="text-align:right;font-size:18px;font-weight:bold;color:#1c1c1c;padding:11px 14px;">' + fmt(vipFinalForEmail) + '</td></tr>' +
        '<tr><td colspan="2" style="text-align:center;font-size:12px;color:#5a8a5a;padding:7px 14px 11px;border-top:1px solid #e0d6c8;">You save ' + fmt(savings) + ' with your Old Hippy VIP Club Membership</td></tr>' +
        (discountedItems < 1500000
          ? '<tr><td colspan="2" style="text-align:center;font-size:12px;color:#8a7a6a;padding:5px 14px 10px;">You are <strong>' + fmt(1500000 - discountedItems) + '</strong> away from free shipping (dock to dock Western Canada)</td></tr>'
          : '<tr><td colspan="2" style="text-align:center;font-size:12px;color:#5a8a5a;font-weight:bold;padding:5px 14px 10px;">&#10003; You qualify for free dock-to-dock shipping!</td></tr>');
    } else if (hasPickupCredit) {
      var pickupFinalForEmail = regularTotal - pickupCredit;
      pricingHtml +=
        '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:12px;color:#555;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">Subtotal</td><td style="text-align:right;font-size:13px;color:#1c1c1c;padding:9px 14px;">' + fmt(regularTotal) + '</td></tr>' +
        '<tr style="border-bottom:2px solid #d5cdc3;"><td style="font-size:12px;color:#555;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">Edmonton Pickup Credit</td><td style="text-align:right;font-size:13px;color:#1c1c1c;padding:9px 14px;">&minus;' + fmt(pickupCredit) + '</td></tr>';
      if (promoApplied) {
        var promoAmt = Math.round(pickupFinalForEmail * 0.05);
        pricingHtml += '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:12px;color:#5a8a5a;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">&#127991; Promo Code WELCOME26 (5% off)</td><td style="text-align:right;font-size:13px;color:#5a8a5a;padding:9px 14px;">&minus;' + fmt(promoAmt) + '</td></tr>';
        pickupFinalForEmail -= promoAmt;
      }
      preTaxTotal = pickupFinalForEmail;
      pricingHtml += '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:13px;font-weight:bold;color:#1c1c1c;padding:11px 14px;text-transform:uppercase;letter-spacing:0.08em;">Total After Credit</td><td style="text-align:right;font-size:18px;font-weight:bold;color:#1c1c1c;padding:11px 14px;">' + fmt(pickupFinalForEmail) + '</td></tr>';
    } else {
      var baseFinalForEmail = regularTotal;
      if (promoApplied) {
        var promoAmt = Math.round(baseFinalForEmail * 0.05);
        pricingHtml += '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:12px;color:#555;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">Subtotal</td><td style="text-align:right;font-size:13px;color:#1c1c1c;padding:9px 14px;">' + fmt(regularTotal) + '</td></tr>';
        pricingHtml += '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:12px;color:#5a8a5a;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">&#127991; Promo Code WELCOME26 (5% off)</td><td style="text-align:right;font-size:13px;color:#5a8a5a;padding:9px 14px;">&minus;' + fmt(promoAmt) + '</td></tr>';
        baseFinalForEmail -= promoAmt;
        pricingHtml += '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:13px;font-weight:bold;color:#1c1c1c;padding:11px 14px;text-transform:uppercase;letter-spacing:0.08em;">Total After Discount</td><td style="text-align:right;font-size:18px;font-weight:bold;color:#1c1c1c;padding:11px 14px;">' + fmt(baseFinalForEmail) + '</td></tr>';
      } else {
        pricingHtml += '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:13px;font-weight:bold;color:#1c1c1c;padding:11px 14px;text-transform:uppercase;letter-spacing:0.08em;">Subtotal</td><td style="text-align:right;font-size:18px;font-weight:bold;color:#1c1c1c;padding:11px 14px;">' + fmt(regularTotal) + '</td></tr>';
      }
      preTaxTotal = baseFinalForEmail;
    }

    var poGst          = Math.round((preTaxTotal - giftCardTotal) * 0.05);
    var poTotalWithGst = preTaxTotal + poGst;
    var DEPOSIT        = 50000;
    pricingHtml +=
      '<tr><td style="font-size:12px;color:#555;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">GST (5%)</td><td style="text-align:right;font-size:13px;color:#1c1c1c;padding:9px 14px;">' + fmt(poGst) + '</td></tr>' +
      '<tr style="border-top:2px solid #d5cdc3;border-bottom:1px solid #e0d6c8;"><td style="font-size:13px;font-weight:bold;color:#1c1c1c;padding:11px 14px;text-transform:uppercase;letter-spacing:0.08em;">Total with GST</td><td style="text-align:right;font-size:18px;font-weight:bold;color:#1c1c1c;padding:11px 14px;">' + fmt(poTotalWithGst) + '</td></tr>' +
      '<tr style="background:#fdf6e3;"><td style="font-size:12px;font-weight:bold;color:#7a5c1e;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">Deposit Due at Checkout</td><td style="text-align:right;font-size:13px;font-weight:bold;color:#7a5c1e;padding:9px 14px;">$500.00</td></tr>' +
      '<tr style="background:#fdf6e3;"><td style="font-size:12px;font-weight:bold;color:#7a5c1e;padding:9px 14px 11px;text-transform:uppercase;letter-spacing:0.08em;">Balance Due After Deposit</td><td style="text-align:right;font-size:13px;font-weight:bold;color:#7a5c1e;padding:9px 14px 11px;">' + fmt(poTotalWithGst - DEPOSIT) + '</td></tr>';
    pricingHtml += '</table>';

    var nextSteps =
      '<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#f7f3ee;border:1px solid #e0d6c8;border-radius:6px;">' +
      '<tr><td style="padding:16px 18px;">' +
      '<p style="margin:0 0 10px;font-size:11px;font-weight:bold;color:#2c1e0f;letter-spacing:0.15em;text-transform:uppercase;">What Happens Next</p>' +
      '<p style="margin:0 0 10px;font-size:13px;color:#555;line-height:1.8;"><strong>Step 1:</strong> This is an order acknowledgment of your selected items. Complete the $500 deposit at checkout.</p>' +
      '<p style="margin:0 0 10px;font-size:13px;color:#555;line-height:1.8;"><strong>Step 2:</strong> We will mail you our wood finish samples and upholstery swatches so you can make your selections at home. Once your order details are confirmed and we are ready to move into production, we will request a <strong>50% production deposit</strong>. Your 8&ndash;12 week build timeline begins upon receipt of that deposit. The remaining balance will be due upon completion of your furniture, prior to shipping. <strong>Your $500 pre-order deposit will be applied toward your final balance.</strong> The deposit is non-refundable.</p>' +
      '<p style="margin:0;font-size:13px;color:#555;line-height:1.8;">Until your final order confirmation and production deposit are received, you are welcome to make changes to your order, including adding additional items.</p>' +
      '</td></tr></table>';

    var header =
      '<table cellpadding="0" cellspacing="0" border="0" style="max-width:600px;width:100%;margin:0 auto;">' +
      '<tr><td style="background:#2c1e0f;padding:28px 40px;text-align:center;border-radius:8px 8px 0 0;">' +
      '<p style="margin:0;font-size:11px;font-weight:bold;color:#b8965a;letter-spacing:0.2em;text-transform:uppercase;">Old Hippy Wood Products</p>' +
      '<p style="margin:10px 0 0;font-size:22px;color:#e8d9b5;letter-spacing:0.03em;">Deposit Order Acknowledgment Invoice</p>' +
      '</td></tr>';

    var bodySection =
      '<tr><td style="background:#ffffff;padding:36px 40px;border-radius:0 0 8px 8px;">' +
      '<p style="margin:0 0 6px;font-size:20px;font-weight:bold;color:#1c1c1c;">Hi ' + esc(name) + ',</p>' +
      '<p style="margin:0 0 8px;font-size:14px;color:#666;line-height:1.7;">You will receive a copy of the deposit acknowledgment invoice by email.</p>' +
      '<p style="margin:0 0 4px;font-size:14px;color:#666;line-height:1.7;">When you place your deposit, we will mail wood finish samples and upholstery swatches so you can make your final selections from home.</p>' +
      (phone ? '<p style="margin:0 0 20px;font-size:13px;color:#999;">Phone on file: ' + esc(phone) + '</p>' : '<p style="margin:0 0 20px;"></p>') +
      '<p style="margin:0 0 12px;font-size:11px;font-weight:bold;color:#999;letter-spacing:0.15em;text-transform:uppercase;border-bottom:1px solid #e0d6c8;padding-bottom:8px;">Your Selections</p>' +
      itemsHtml +
      pricingHtml +
      nextSteps +
      '</td></tr>';

    var footer =
      '<tr><td style="padding:20px 40px;text-align:center;">' +
      '<p style="margin:0;font-size:12px;color:#999;">Old Hippy Wood Products &bull; oldhippyonline.com</p>' +
      '<p style="margin:6px 0 0;font-size:12px;color:#bbb;">Questions? Contact us at shop@oldhippyonline.com</p>' +
      '</td></tr>' +
      '</table>';

    var wrapper =
      '<div style="background:#f4f0eb;padding:24px 16px;font-family:Georgia,serif;">' +
      header + bodySection + footer +
      '</div>';

    return wrapper;
  }

  function ejsSend(toEmail, replyTo, subject, html, tag) {
    if (typeof emailjs === 'undefined') {
      console.warn('[EmailJS] SDK not yet loaded — ' + tag);
      return;
    }
    console.log('[EmailJS] Sending "' + tag + '" to ' + toEmail);
    emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      {
        to_email:     toEmail,
        reply_to:     replyTo,
        subject:      subject,
        message_html: html
      }
    ).then(function () {
      console.log('[EmailJS] OK — ' + tag + ' → ' + toEmail);
    }).catch(function (e) {
      console.error('[EmailJS] FAILED — ' + tag + ' → ' + toEmail, e);
    });
  }

  // Customer confirmation email
  window.RH_EMAILJS_SEND = function (name, email, productItems, membershipItems, isLoggedInMember, phone, promoApplied) {
    ejsSend(
      email,
      'shop@oldhippyonline.com',
      'Deposit Order Acknowledgment Invoice — Old Hippy Wood Products',
      buildHtml(name, productItems, membershipItems, isLoggedInMember, phone, promoApplied),
      'Customer email'
    );
  };

  // Admin copy — same HTML, sent to store owner
  window.RH_EMAILJS_SEND_ADMIN = function (name, email, productItems, membershipItems, isLoggedInMember, phone, promoApplied) {
    var adminHtml =
      '<div style="background:#2c1e0f;padding:10px 20px;font-family:Georgia,serif;border-radius:6px 6px 0 0;">' +
      '<p style="margin:0;font-size:12px;color:#e8d9b5;letter-spacing:0.05em;">' +
      '<strong>ADMIN COPY</strong> &mdash; Customer: ' + esc(name) + ' &lt;' + esc(email) + '&gt;' + (phone ? ' &bull; ' + esc(phone) : '') + '</p>' +
      '</div>' +
      buildHtml(name, productItems, membershipItems, isLoggedInMember, phone, promoApplied);

    ejsSend(
      'shop@oldhippy.com',
      email,
      '[Pre-Order] ' + name + ' — ' + email,
      adminHtml,
      'Admin email'
    );
  };

  // ── SHIPPING ESTIMATE EMAILS ─────────────────────────────────────────────

  function buildEstHtml(name, email, productItems, membershipItems, isAdmin, isLoggedInMember, phone) {
    var PICKUP_VID      = 49210694336740;
    var hasPickupCredit = productItems.some(function (i) { return i.variant_id == PICKUP_VID; });
    var filteredProd    = productItems.filter(function (i) { return i.variant_id != PICKUP_VID; });
    var allItems        = filteredProd.concat(membershipItems);
    var giftCardTotal   = filteredProd.reduce(function (s, i) { return s + (i.url && i.url.indexOf('old-hippy-wood-products-gift-card') !== -1 ? i.original_line_price : 0); }, 0);
    var regularTotal    = filteredProd.reduce(function (s, i) { return s + i.original_line_price + getLCUpchargeLine(i); }, 0);
    var discountableTotal = regularTotal - giftCardTotal;
    var pickupCredit    = hasPickupCredit ? Math.min(Math.round(discountableTotal * 0.05), 75000) : 0;

    var itemsHtml = '';
    allItems.forEach(function (item) {
      var imgHtml = item.image
        ? '<img src="' + esc(item.image) + '" width="76" height="76" style="display:block;border-radius:4px;object-fit:cover;" alt="">'
        : '<div style="width:76px;height:76px;background:#e8e1d8;border-radius:4px;"></div>';
      var detailHtml = '';
      if (item.variant_title && item.variant_title !== 'Default Title') detailHtml += '<p style="margin:0 0 2px;font-size:12px;color:#777;">' + esc(item.variant_title) + '</p>';
      if (item.sku) detailHtml += '<p style="margin:0 0 4px;font-size:11px;color:#aaa;">SKU: ' + esc(item.sku) + '</p>';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          if (key.charAt(0) === '_' || !item.properties[key]) return;
          detailHtml += '<p style="margin:0 0 2px;font-size:12px;color:#555;"><strong style="color:#333;">' + esc(key) + ':</strong> ' + esc(item.properties[key]) + '</p>';
        });
      }
      var isMemberFreeItem = membershipItems.indexOf(item) !== -1 && item.final_line_price === 0;
      var itemPriceStr = isMemberFreeItem
        ? '<span style="text-decoration:line-through;color:#bbb;font-size:11px;">' + fmt(item.original_line_price) + '</span> <span style="color:#5a8a5a;font-weight:bold;">FREE</span>'
        : fmt(item.original_line_price + getLCUpchargeLine(item));
      itemsHtml +=
        '<table width="100%" cellpadding="0" cellspacing="0" border="0" style="border:1px solid #e0d6c8;border-radius:6px;margin-bottom:12px;">' +
        '<tr>' +
        '<td width="88" style="padding:12px;vertical-align:top;">' + imgHtml + '</td>' +
        '<td style="padding:12px 12px 12px 0;vertical-align:top;">' +
        '<p style="margin:0 0 4px;font-size:14px;font-weight:bold;color:#1c1c1c;line-height:1.3;">' + esc(item.product_title) + '</p>' + detailHtml + '</td>' +
        '<td style="padding:12px;vertical-align:bottom;text-align:right;white-space:nowrap;">' +
        '<p style="margin:0;font-size:12px;color:#999;">Qty: ' + item.quantity + '</p>' +
        '<p style="margin:4px 0 0;font-size:15px;font-weight:bold;color:#1c1c1c;">' + itemPriceStr + '</p>' +
        '</td></tr></table>';
    });

    var hasMembership  = membershipItems.length > 0 || !!isLoggedInMember;
    var estPreTaxTotal = 0;
    var pricingHtml = '<table width="100%" cellpadding="0" cellspacing="0" border="0" style="border:1px solid #e0d6c8;border-radius:6px;margin:8px 0 20px;">';
    if (hasMembership) {
      var rhVipFnEst = window.rhGetVipRate || function() { return 0.8; };
      var discountedItems = filteredProd.reduce(function(t, i) {
        var isGC = i.url && i.url.indexOf('old-hippy-wood-products-gift-card') !== -1;
        if (isGC) return t;
        return t + Math.round((i.original_line_price + getLCUpchargeLine(i)) * rhVipFnEst(i));
      }, 0);
      var vipSubtotal = discountedItems + giftCardTotal;
      var savings     = discountableTotal - discountedItems;
      var vipFinal    = vipSubtotal - pickupCredit;
      estPreTaxTotal  = vipFinal;
      pricingHtml +=
        '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:12px;color:#aaa;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">Regular Subtotal</td><td style="text-align:right;font-size:13px;color:#bbb;text-decoration:line-through;padding:9px 14px;">' + fmt(regularTotal) + '</td></tr>' +
        '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:13px;font-weight:bold;color:#1c1c1c;padding:11px 14px;text-transform:uppercase;letter-spacing:0.08em;">VIP Member Subtotal (20% off)</td><td style="text-align:right;font-size:18px;font-weight:bold;color:#1c1c1c;padding:11px 14px;">' + fmt(vipSubtotal) + '</td></tr>';
      if (membershipItems.length > 0) {
        var membershipFeeTotal    = membershipItems.reduce(function (s, i) { return s + i.final_line_price; }, 0);
        var membershipFeeOriginal = membershipItems.reduce(function (s, i) { return s + i.original_line_price; }, 0);
        var memberFeeDisp = membershipFeeTotal === 0
          ? '<span style="text-decoration:line-through;color:#bbb;font-size:11px;">' + fmt(membershipFeeOriginal) + '</span> <span style="color:#5a8a5a;font-weight:bold;">FREE</span>'
          : fmt(membershipFeeTotal);
        pricingHtml += '<tr style="border-bottom:' + (hasPickupCredit ? '1' : '0') + 'px solid #e0d6c8;"><td style="font-size:12px;color:#555;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">VIP Membership Fee (1 year)</td><td style="text-align:right;font-size:13px;color:#1c1c1c;padding:9px 14px;">' + memberFeeDisp + '</td></tr>';
      }
      if (hasPickupCredit) {
        pricingHtml +=
          '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:12px;color:#555;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">Edmonton Pickup Credit</td><td style="text-align:right;font-size:13px;color:#1c1c1c;padding:9px 14px;">&minus;' + fmt(pickupCredit) + '</td></tr>' +
          '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:13px;font-weight:bold;color:#1c1c1c;padding:11px 14px;text-transform:uppercase;letter-spacing:0.08em;">VIP Member Total</td><td style="text-align:right;font-size:18px;font-weight:bold;color:#1c1c1c;padding:11px 14px;">' + fmt(vipFinal) + '</td></tr>';
      }
      pricingHtml += '<tr><td colspan="2" style="text-align:center;font-size:12px;color:#5a8a5a;padding:7px 14px 11px;border-top:1px solid #e0d6c8;">Estimated savings with VIP Membership: ' + fmt(savings) + '</td></tr>';
      pricingHtml += discountedItems < 1500000
        ? '<tr><td colspan="2" style="text-align:center;font-size:12px;color:#8a7a6a;padding:5px 14px 10px;">You are <strong>' + fmt(1500000 - discountedItems) + '</strong> away from free shipping (dock to dock Western Canada)</td></tr>'
        : '<tr><td colspan="2" style="text-align:center;font-size:12px;color:#5a8a5a;font-weight:bold;padding:5px 14px 10px;">&#10003; You qualify for free dock-to-dock shipping!</td></tr>';
    } else if (hasPickupCredit) {
      var creditTotal = regularTotal - pickupCredit;
      estPreTaxTotal  = creditTotal;
      pricingHtml +=
        '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:12px;color:#555;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">Subtotal</td><td style="text-align:right;font-size:13px;color:#1c1c1c;padding:9px 14px;">' + fmt(regularTotal) + '</td></tr>' +
        '<tr style="border-bottom:2px solid #d5cdc3;"><td style="font-size:12px;color:#555;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">Edmonton Pickup Credit</td><td style="text-align:right;font-size:13px;color:#1c1c1c;padding:9px 14px;">&minus;' + fmt(pickupCredit) + '</td></tr>' +
        '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:13px;font-weight:bold;color:#1c1c1c;padding:11px 14px;text-transform:uppercase;letter-spacing:0.08em;">Total After Credit</td><td style="text-align:right;font-size:18px;font-weight:bold;color:#1c1c1c;padding:11px 14px;">' + fmt(creditTotal) + '</td></tr>';
    } else {
      estPreTaxTotal = regularTotal;
      pricingHtml += '<tr style="border-bottom:1px solid #e0d6c8;"><td style="font-size:13px;font-weight:bold;color:#1c1c1c;padding:11px 14px;text-transform:uppercase;letter-spacing:0.08em;">Order Subtotal</td><td style="text-align:right;font-size:18px;font-weight:bold;color:#1c1c1c;padding:11px 14px;">' + fmt(regularTotal) + '</td></tr>';
    }

    var estGst          = Math.round((estPreTaxTotal - giftCardTotal) * 0.05);
    var estTotalWithGst = estPreTaxTotal + estGst;
    pricingHtml +=
      '<tr><td style="font-size:12px;color:#555;padding:9px 14px;text-transform:uppercase;letter-spacing:0.08em;">GST (5%)</td><td style="text-align:right;font-size:13px;color:#1c1c1c;padding:9px 14px;">' + fmt(estGst) + '</td></tr>' +
      '<tr style="border-top:2px solid #d5cdc3;"><td style="font-size:13px;font-weight:bold;color:#1c1c1c;padding:11px 14px;text-transform:uppercase;letter-spacing:0.08em;">Total with GST</td><td style="text-align:right;font-size:18px;font-weight:bold;color:#1c1c1c;padding:11px 14px;">' + fmt(estTotalWithGst) + '</td></tr>';
    pricingHtml += '</table>';

    var noteBox = isAdmin
      ? '<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#fff8e8;border:2px solid #b8965a;border-radius:6px;margin-bottom:24px;"><tr><td style="padding:14px 18px;"><p style="margin:0;font-size:13px;font-weight:bold;color:#7a5c1e;">SHIPPING ESTIMATE REQUEST — Follow up with this customer</p><p style="margin:6px 0 0;font-size:13px;color:#555;">Customer: <strong>' + esc(name) + '</strong> &lt;' + esc(email) + '&gt;' + (phone ? ' &bull; ' + esc(phone) : '') + '</p></td></tr></table>'
      : '<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#f7f3ee;border:1px solid #e0d6c8;border-radius:6px;"><tr><td style="padding:16px 18px;"><p style="margin:0 0 8px;font-size:11px;font-weight:bold;color:#2c1e0f;letter-spacing:0.15em;text-transform:uppercase;">What Happens Next</p><p style="margin:0;font-size:13px;color:#555;line-height:1.8;">A team member will be in touch with you shortly to let you know if your selections are in stock.</p></td></tr></table>';

    var header =
      '<table cellpadding="0" cellspacing="0" border="0" style="max-width:600px;width:100%;margin:0 auto;">' +
      '<tr><td style="background:#2c1e0f;padding:28px 40px;text-align:center;border-radius:8px 8px 0 0;">' +
      '<p style="margin:0;font-size:11px;font-weight:bold;color:#b8965a;letter-spacing:0.2em;text-transform:uppercase;">Old Hippy Wood Products</p>' +
      '<p style="margin:10px 0 0;font-size:22px;color:#e8d9b5;letter-spacing:0.03em;">Stock Check Request</p>' +
      '</td></tr>';

    var bodySection =
      '<tr><td style="background:#ffffff;padding:36px 40px;border-radius:0 0 8px 8px;">' +
      '<p style="margin:0 0 6px;font-size:20px;font-weight:bold;color:#1c1c1c;">Hi ' + esc(name) + ',</p>' +
      '<p style="margin:0 0 20px;font-size:14px;color:#666;line-height:1.7;">Thank you for submitting your selections! Below is a copy of the items in your cart. A team member will be in touch with you shortly to let you know if your selections are in stock.</p>' +
      noteBox +
      '<p style="margin:20px 0 12px;font-size:11px;font-weight:bold;color:#999;letter-spacing:0.15em;text-transform:uppercase;border-bottom:1px solid #e0d6c8;padding-bottom:8px;">Your Selections</p>' +
      itemsHtml + pricingHtml +
      '</td></tr>';

    var footer =
      '<tr><td style="padding:20px 40px;text-align:center;">' +
      '<p style="margin:0;font-size:12px;color:#999;">Old Hippy Wood Products &bull; oldhippyonline.com</p>' +
      '<p style="margin:6px 0 0;font-size:12px;color:#bbb;">Questions? Contact us at shop@oldhippyonline.com</p>' +
      '</td></tr></table>';

    return '<div style="background:#f4f0eb;padding:24px 16px;font-family:Georgia,serif;">' + header + bodySection + footer + '</div>';
  }

  // Customer confirmation for shipping estimate
  window.RH_EMAILJS_SEND_EST = function (name, email, productItems, membershipItems, isLoggedInMember, phone) {
    ejsSend(
      email,
      'shop@oldhippyonline.com',
      'Your Stock Check Request — Old Hippy Wood Products',
      buildEstHtml(name, email, productItems, membershipItems, false, isLoggedInMember, phone),
      'Est customer email'
    );
  };

  // Admin copy for shipping estimate
  window.RH_EMAILJS_SEND_EST_ADMIN = function (name, email, productItems, membershipItems, isLoggedInMember, phone) {
    ejsSend(
      'shop@oldhippy.com',
      email,
      '[Stock Check] ' + name + ' — ' + email,
      buildEstHtml(name, email, productItems, membershipItems, true, isLoggedInMember, phone),
      'Est admin email'
    );
  };

  // 24-hour flash discount code email
  window.RH_EMAILJS_SEND_FLASH = function (toEmail, code) {
    var now = new Date();
    var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    var diff = midnight - now;
    var hh = Math.floor(diff / 3600000);
    var mm = Math.floor((diff % 3600000) / 60000);
    var timeLeft = hh + 'h ' + mm + 'm';
    var html =
      '<div style="background:#f4f0eb;padding:24px 16px;font-family:Georgia,serif;">' +
      '<table cellpadding="0" cellspacing="0" border="0" style="max-width:500px;width:100%;margin:0 auto;">' +
      '<tr><td style="background:#2c1e0f;padding:24px 32px;text-align:center;border-radius:8px 8px 0 0;">' +
      '<p style="margin:0;font-size:11px;font-weight:bold;color:#b8965a;letter-spacing:0.2em;text-transform:uppercase;">Old Hippy Wood Products</p>' +
      '<p style="margin:8px 0 0;font-size:20px;color:#e8d9b5;">&#9889; Your 24-Hour Flash Discount</p>' +
      '</td></tr>' +
      '<tr><td style="background:#fff;padding:32px;border-radius:0 0 8px 8px;">' +
      '<p style="margin:0 0 16px;font-size:15px;color:#1c1c1c;">Here is your exclusive flash discount code:</p>' +
      '<div style="background:#2c1e0f;border:2px solid #b8965a;border-radius:6px;padding:24px;text-align:center;margin:0 0 20px;">' +
      '<p style="margin:0;font-size:30px;font-weight:bold;color:#b8965a;letter-spacing:0.15em;">' + esc(code) + '</p>' +
      '<p style="margin:10px 0 0;font-size:13px;color:#e8d9b5;">Extra 5% off your order &mdash; expires in ' + timeLeft + '</p>' +
      '</div>' +
      '<p style="margin:0 0 12px;font-size:13px;color:#555;line-height:1.6;">Enter this code in the flash discount field on the deposit popup on our website to unlock your exclusive price. This code expires at midnight tonight.</p>' +
      '<p style="margin:0;font-size:12px;color:#999;">Old Hippy Wood Products &bull; oldhippyonline.com</p>' +
      '</td></tr></table></div>';
    ejsSend(toEmail, 'shop@oldhippyonline.com', '&#9889; Your Old Hippy Flash Discount Code — ' + code, html, 'Flash code email');
  };

  // VIP free membership signup — sends admin notification + customer confirmation
  window.RH_EMAILJS_SEND_VIP_SIGNUP = function (name, email) {
    var header =
      '<table cellpadding="0" cellspacing="0" border="0" style="max-width:500px;width:100%;margin:0 auto;">' +
      '<tr><td style="background:#2c1e0f;padding:24px 32px;text-align:center;border-radius:8px 8px 0 0;">' +
      '<p style="margin:0;font-size:11px;font-weight:bold;color:#b8965a;letter-spacing:0.2em;text-transform:uppercase;">Old Hippy Wood Products</p>' +
      '<p style="margin:8px 0 0;font-size:20px;color:#e8d9b5;">VIP Club Membership</p>' +
      '</td></tr>';
    var footer =
      '<tr><td style="padding:20px 32px;text-align:center;">' +
      '<p style="margin:0;font-size:12px;color:#999;">Old Hippy Wood Products &bull; oldhippyonline.com</p>' +
      '</td></tr></table>';

    // Admin notification
    var adminBody =
      '<tr><td style="background:#fff;padding:32px;border-radius:0 0 8px 8px;">' +
      '<p style="margin:0 0 6px;font-size:11px;font-weight:bold;color:#b8965a;letter-spacing:0.15em;text-transform:uppercase;">New VIP Signup</p>' +
      '<p style="margin:0 0 16px;font-size:15px;color:#1c1c1c;font-weight:700;">' + esc(name) + '</p>' +
      '<p style="margin:0 0 4px;font-size:13px;color:#555;">Email: <strong>' + esc(email) + '</strong></p>' +
      '<p style="margin:16px 0 0;font-size:12px;color:#999;">Please activate their VIP membership and add them to your customer list.</p>' +
      '</td></tr>';
    ejsSend('shop@oldhippy.com', email, '[VIP Signup] ' + name + ' — ' + email,
      '<div style="background:#f4f0eb;padding:24px 16px;font-family:Georgia,serif;">' + header + adminBody + footer + '</div>',
      'VIP signup admin');

    // Customer confirmation
    var custBody =
      '<tr><td style="background:#fff;padding:32px;border-radius:0 0 8px 8px;">' +
      '<p style="margin:0 0 12px;font-size:18px;font-weight:700;color:#1c1c1c;">Welcome to the VIP Club, ' + esc(name) + '!</p>' +
      '<p style="margin:0 0 16px;font-size:14px;color:#555;line-height:1.7;">Thank you for joining the Old Hippy VIP Club. Your membership gives you <strong>20% off sitewide</strong> on every order for one full year.</p>' +
      '<ul style="margin:0 0 20px;padding-left:20px;font-size:13px;color:#555;line-height:2;">' +
      '<li><strong>20% off every order</strong> — applied automatically at checkout</li>' +
      '<li><strong>Unlimited purchases</strong> throughout your membership year</li>' +
      '<li><strong>No auto-renewal</strong> — expires after one year with no charge</li>' +
      '</ul>' +
      '<p style="margin:0 0 20px;font-size:13px;color:#555;line-height:1.7;">Our team will be in touch shortly to confirm your membership is fully activated. In the meantime, feel free to browse our collections.</p>' +
      '<a href="https://www.oldhippyonline.com/collections/all" style="display:inline-block;background:#b8965a;color:#2c1e0f;text-decoration:none;padding:14px 32px;font-size:11px;font-weight:700;letter-spacing:0.15em;text-transform:uppercase;border-radius:2px;">Shop &amp; Save 20%</a>' +
      '</td></tr>';
    ejsSend(email, 'shop@oldhippyonline.com', 'Welcome to the Old Hippy VIP Club!',
      '<div style="background:#f4f0eb;padding:24px 16px;font-family:Georgia,serif;">' + header + custBody + footer + '</div>',
      'VIP signup customer');
  };
})();
